// Reads (and clears) the pending redirect stashed by sw.js's notificationclick
// handler — see the matching stashPendingPushRedirect() there. Same DB name,
// object store, and key must be kept in sync between the two files.
export function consumePendingPushRedirect() {
  return new Promise(resolve => {
    if (!('indexedDB' in window)) {
      resolve(null);
      return;
    }

    const req = indexedDB.open('smart-campus-push', 1);
    req.onupgradeneeded = () => {
      req.result.createObjectStore('pending');
    };
    req.onsuccess = () => {
      const db = req.result;
      const tx = db.transaction('pending', 'readwrite');
      const store = tx.objectStore('pending');
      const getReq = store.get('redirect');
      getReq.onsuccess = () => {
        const url = getReq.result || null;
        if (url) {
          store.delete('redirect');
        }
        tx.oncomplete = () => {
          db.close();
          resolve(url);
        };
      };
      getReq.onerror = () => {
        db.close();
        resolve(null);
      };
    };
    req.onerror = () => resolve(null);
  });
}
